// Store
import {setLoading} from './generalActions';
import {AppDispatch} from '../../store';
import sessionServices from '../../../api/sessionServices';

// Components and Subcomponents
import {ERROR_MODAL} from '../../../components/subComponents/responseModals';

// Utils
import {reloadWindow, setLocalStorageItem} from "../../../utils/generalUtils";


export const decryptTempToken = (code: string) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  sessionServices.decryptTempToken(code)
    .then((response) => {
      Object.keys(response.data).forEach(key => {
        setLocalStorageItem(key, response.data[key]);
      });
      dispatch(setLoading(false));
      reloadWindow();
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}
